import { LabeledSelect } from '@/components';
import { useConsecutiveFiscalYears } from '@/features/project/_hooks/consecutive';
import { PROJECT_BASE_DIR } from '@/features/project/review-sheet/utils/constants';
import { useId } from '@/hooks';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router';

type Props = {
  fiscalYear: number;
};

export const FiscalYearSelector: FC<Props> = ({ fiscalYear }) => {
  const { t } = useTranslation();
  const { id: projectId } = useId();
  const consecutiveFiscalYears = useConsecutiveFiscalYears({ id: projectId });
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const queryParams = searchParams.toString();

  return (
    <LabeledSelect
      label={t('created-fiscal-year')}
      value={fiscalYear}
      options={consecutiveFiscalYears.data?.map((d) => ({
        value: d.id,
        label: d.fiscalYear,
      }))}
      onChange={(id) => {
        if (id.toString() !== projectId) {
          navigate(`${PROJECT_BASE_DIR}/${id}?${queryParams}`);
        }
      }}
      style={{ width: 80 }}
    />
  );
};
